import React from "react";
import Skeleton from "react-loading-skeleton";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../stylesheet/_grid.scss";

const ZefiLogo: React.FC<{
  path: string;
  logoPath: string;
  footerLogo?: boolean;
}> = ({ path, logoPath, footerLogo }) => {
  const { t, ready, i18n } = useTranslation();
  const getPathString = () => {
    if (path.includes("/cafe")) {
      return `/${i18n.language}/cafe`;
    } else if (path.includes("/academy")) {
      return `/${i18n.language}/academy`;
    }
    return `/${i18n.language}`;
  };

  const getNavbarTitle = () => {
    if (ready) {
      return !footerLogo ? (
        path.includes("/cafe") ? (
          <h4>{t("navbar.zecafe")}</h4>
        ) : path.includes("/academy") ? (
          <h4>{t("navbar.zeacademy")}</h4>
        ) : (
          <h4>{t("navbar.zefi")}</h4>
        )
      ) : (
        ""
      );
    }
    return (
      <div className="skeleton-text-logo">
        <Skeleton
          style={{
            height: "3vh",
          }}
        />
      </div>
    );
  };

  return (
    <Link
      className="logo-container d-flex align-items-center"
      to={getPathString()}
    >
      <div
        className="logo d-flex align-items-center"
        data-testid="zefi-logo-container"
      >
        <img className="logo" src={logoPath} />
        {getNavbarTitle()}
      </div>
    </Link>
  );
};

export default ZefiLogo;
